import React from "react";
import { graphql } from "gatsby";
import { motion } from "framer-motion";
import { PrismicRichText } from "@prismicio/react";
import * as styles from "./stats.module.css";

export const Stats = ({ slice }) => {
  const { heading } = slice?.primary || {};

  return (
    <section data-tilt-scheme="center">
      <div className="section-split-5-6 page-width padding-section-vertical">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6, ease: [0.25, 0.1, 0.25, 1] }}
        >
          {heading && (
            <PrismicRichText
              field={heading.richText}
              components={{
                heading2: ({ children }) => <h2 className="h2">{children}</h2>,
              }}
            />
          )}
        </motion.div>
        <div>
          <div className={styles.statsWrapper + " grid"}>
            {slice.items?.map(({ stat_metric, stat_unit }, index) => (
              <motion.div
                key={stat_metric.text}
                className={styles.stat}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{
                  duration: 0.5,
                  delay: index * 0.1,
                  ease: [0.25, 0.1, 0.25, 1],
                }}
              >
                <span className={styles.statMetric}>{stat_metric.text}</span>
                <span className={styles.statUnit}>{stat_unit.text}</span>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export const query = graphql`
  fragment HomepageDataBodyStats on PrismicHomepageDataBodyStats {
    primary {
      heading {
        richText
      }
    }
    items {
      stat_metric {
        text
      }
      stat_unit {
        text
      }
    }
  }
`;
